import React, { Component } from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import { Card, CardContent, FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import * as types from 'constants/actionTypes';
import LOOKUP from "constants/lookup";
import WithRouter from "custom/withRouter";
import { saveUserReportRole, saveUserPageRole, getUserReportRole, getUserPageRole, getRoles, getRole, saveRole, updateRole, getPolicies } from "actions/EntityActions";
import { formInput, clearFormInput, initializeRole } from "actions/FormActions";
import { showError, showSnackbar } from "actions/CommonActions";
import { userRoleEditCrumb, userRoleAddCrumb } from "utils/breadcrumbInfo";
import { selectUserRoleAccessModel } from "selectors/entitySelector";
// Basic Components
import Grid from "screens/components/basic/Grid";
import CardSimple from "screens/components/basic/CardSimple";
import TextInput from "screens/components/basic/TextInput";
import Button from "screens/components/basic/Button";
import CheckInput from "screens/components/basic/CheckInput";
import PageHeaderWithButton from "screens/components/basic/PageHeaderWithButton";

const name = "role";

const Label = ({ selected, type }) => (
    <span style={{ fontSize: '15px' }}>
        {selected ? 'Clear ' : 'Select '}
        <span style={{ color: 'rgb(122,96,229)', fontWeight: 'bold', fontSize: '16px' }}>ALL</span>
        {` ${type}s`}
    </span>
);

class UserRoleSave extends Component {
    constructor(props, context) {
        super(props, context);

    this.state = {
      status: "",
      pageCheckboxStatus: '',
      reportCheckboxStatus: '',
      reportAccess: {},
    };

    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleCheckAllReport = this.handleCheckAllReport.bind(this);
    this.handleCheckAllPage = this.handleCheckAllPage.bind(this);
    this.getCheckboxStatus = this.getCheckboxStatus.bind(this)
  }

  // check if we have id in the URL
  componentDidMount() {
    const userRoleId = this.props.params.id;
    // if true dispatch an action to retrive the data from API and set Status to EDIT
    if (userRoleId) {
      const userRole = this.getUserLabel(userRoleId);
      if (userRole && userRole !== 'undefined') {
        const storedUserRole = localStorage.getItem('SelectedUserRole');
        if (userRole !== storedUserRole) {
          localStorage.setItem('SelectedUserRole', userRole);
        }
      }

      const form = this.props.formState;

      const pageCheckboxStatus = this.getCheckboxStatus(form, 'Page');
      const reportCheckboxStatus = this.getCheckboxStatus(form, 'Report');

      this.setState({
        status: "EDIT",
        pageCheckboxStatus,
        reportCheckboxStatus, 
      });

      this.props.getRoles();
      this.props.getRole(userRoleId, name);
      this.props.getUserReportRole(userRoleId);
      this.props.getUserPageRole(userRoleId);
      this.props.getPolicies();

      this.props.formInput(userRoleId, "roleId")
    }
    // if false dispatch an action to clean the form and set default values, Status to ADD
    else {
      this.setState(pState => ({ ...pState, status: "ADD" }));
      this.props.initializeRole(name);
    }

    const reportAccess = {};
    (this.props.userRoleReport || []).forEach(item => {
      reportAccess[item.reportType] = item.hasAccess;  // set initial checked state
    });
    this.setState({ reportAccess });
  }

  // check if the Save Success or SaveError happened
  componentWillReceiveProps(newProps) {
    if ((newProps.saveSuccess != undefined &&
      newProps.saveSuccess !== this.props.saveSuccess) ||
      (newProps.saveError != undefined &&
        newProps.saveError !== this.props.saveError)
    ) {
      //if does changed call the respective action (SUCCESS OR FAILURE)
      if (newProps.saveSuccess) this.saveSuccess();
      else this.saveFailure(newProps.saveError);
    }
  }

  componentDidUpdate(prevProps) {
    const { saveSuccess, saveError, userRoleReport } = this.props;

    // Check if formState has been updated
    if (this.props.formState !== prevProps.formState) {
      this.updateCheckboxStatus();
    }

    if (saveSuccess && saveSuccess != prevProps.saveSuccess) {
      this.saveSuccess();
    }

    if (saveError && saveError != prevProps.saveError) {
      this.saveFailure(saveError);
    }

    if (userRoleReport !== prevProps.userRoleReport && userRoleReport.length) {
      const reportAccess = {};
      userRoleReport.forEach(item => {
        reportAccess[item.id] = item.hasAccess;  // use `id`, not `reportType` if available
      });
      this.setState({ reportAccess });
    }
  }

  updateCheckboxStatus() {
    const { formState } = this.props;
    if (formState) {
      const pageCheckboxStatus = this.getCheckboxStatus(formState, 'Page');
      const reportCheckboxStatus = this.getCheckboxStatus(formState, 'Report');
      this.setState(pState => ({ ...pState, pageCheckboxStatus, reportCheckboxStatus }));
    }
  }

  // when data is saved successfully
  saveSuccess() {
    this.props.showSuccess(
      this.state.status === "EDIT"
        ? LOOKUP.userRole.editedMessage
        : LOOKUP.userRole.createdMessage
    );
    this.redirectToRoleList();
  }

  selectGroupReports = (groupName, checked) => {
    const { reportAccess } = this.state;
    const report = this.getReportOptions();
    const reportsInGroup = report[groupName] || [];
    
    const updatedAccess = { ...reportAccess };
    reportsInGroup.forEach(report => {
      updatedAccess[report.id] = checked;
      this.props.formInput(checked, `roleReport-${report.id}`);
    });
    
    this.setState({ reportAccess: updatedAccess });
  };

  // when data is not saved, failure
  saveFailure(error) {
    this.props.showError(error);
  }

  redirectToRoleList() {
    this.props.navigate("/userrole");
  }

  saveReportRole() {
    const p = this.props;
    const filteredReportAccessList = (p.accessModel && p.accessModel.reportAccessList)
      ? p.accessModel.reportAccessList.filter(item => item.ReportType && item.HasAccess)
      : [];
    p.saveUserReportRole(filteredReportAccessList);
  }

  savePageRole() {
    const p = this.props;
    const filteredPageAccessList = (p.accessModel && p.accessModel.pageAccessList)
      ? p.accessModel.pageAccessList.filter(item => item.PageCode !== null)
      : [];
    p.saveUserPageRole(filteredPageAccessList);
  }

  compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!Object.prototype.hasOwnProperty.call(a, key) || !Object.prototype.hasOwnProperty.call(b, key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  getReportOptions() {
    const report = this.props.userRoleReport || [];
    const reportArray = {};
  
    report.forEach(item => {
      const group = item.groupName;
      
      if (!reportArray[group]) {
        reportArray[group] = [];
      }
  
      group && reportArray[group].push({
        id: item.id,
        text: item.name,
        hasAccess: item.hasAccess
      });
    });
  
    return reportArray;
  }

  handleCheckboxChange = (reportId, checked) => {
    this.setState(prevState => ({
      reportAccess: {
        ...prevState.reportAccess,
        [reportId]: checked
      }
    }));
  };

  getPageOptions() {
    const menu = this.filterMenu(this.props.hasWebMenu, LOOKUP.menuData);

    return menu.map(item => {
      const id = item.pageId;
      const value = id ? id.toString() : '';
      const category = item.text;
      const pages = (item.items)
        ? item.items
          .filter(nestedItem =>
            nestedItem.pageId &&
            !(nestedItem.text === 'User Role' ||
              nestedItem.link === '/userrole' ||
              nestedItem.component === 'UserRoleList')
          )
          .map(nestedItem => ({ text: nestedItem.text, id: nestedItem.pageId }))
        : [{ text: category, id }];
      return { id, value, category, pages };
    });
  }

  getUserLabel(userId) {
    const p = this.props;
    if (p.rolesList) {
      return p.rolesList.find(obj => obj.id === userId).label;
    }
  }

  filterMenu(hasWebMenu, menuData) {
    if (!hasWebMenu) {
      return menuData.filter(obj => obj.text !== 'Web Menu');
    }
    return menuData;
  }

  handleCheckAll(accessList, prefix, propertyKey, isChecked) {
    const allKeys = accessList.map(item => `role${prefix}-${item[propertyKey]}`);
    allKeys.forEach(key => this.props.formInput(isChecked, key));
  }

  handleCheckAllReport(isChecked) {
    const { reportAccess } = this.state;
    const report = this.getReportOptions();;
    
    const updatedAccess = { ...reportAccess };
    Object.entries(report).forEach(([groupName, group]) => {
      this.props.formInput(isChecked, `roleReport-${groupName}`);
      group.forEach(report => {
        updatedAccess[report.id] = isChecked;
        this.props.formInput(isChecked, `roleReport-${report.id}`);
      });
    });
    
    this.setState({ reportAccess: updatedAccess });
  }

  handleCheckAllPage(event, isChecked) {
    this.handleCheckAll(this.props.accessModel.pageAccessList, "Page", "PageCode", isChecked);
  }

  getCheckboxStatus(formState, prefix) {
    const items = Object.keys(formState).filter(key => key.startsWith(`role${prefix}-`));
    const checkedCount = items.reduce((count, key) => formState[key] ? count + 1 : count, 0);

    if (checkedCount === items.length) {
      return 'all';
    }
  }

  saveRole = () => {
    this.props.clearFormInput(name + "SaveError")
    const selectedPolicies = Object.keys(this.props.formState)
      .filter(item => item.startsWith(`${name}Policy-`) && this.props.formState[item])
      .map(policy => policy.split("-")[1]);

    const policedToDelete = Object.keys(this.props.formState)
      .filter(item => item.startsWith(`${name}Policy-`) && !this.props.formState[item])
      .map(policy => policy.split("-")[1]);

    const model = {
      name: this.props.roleName,
      roleId: this.props.params.id,
      policies: selectedPolicies,
      policiesToDelete: policedToDelete,
      compName: name
    }

    const isEditPage = this.state.status === "EDIT"

    if (isEditPage) {
      this.props.updateRole(model, name);
    } else {
      this.props.saveRole(model, name);
    }
  }

  render() {
    const p = this.props;
    const isEditPage = this.state.status === "EDIT"
    let userRole = p.params.id ? this.getUserLabel(p.params.id) : "";

    if (p.params.id && !userRole) {
      userRole = localStorage.getItem('SelectedUserRole');
    }
    const reportsList = this.getReportOptions();
    const pageList = this.getPageOptions();
    const crumbs = isEditPage ? userRoleEditCrumb : userRoleAddCrumb;
    const form = { ...this.props.formState }

    const groupedPermissions = Object.values((p.policies || []).reduce((acc, permission) => {
      const group = permission.value.split('.')[0];
      if (!acc[group]) {
        acc[group] = { type: group, items: [] };
      }
      acc[group].items.push({ value: permission.value, text: permission.description });
      return acc;
    }, {}));

    return (
      <Grid headerContent={crumbs}>
        <PageHeaderWithButton title={userRole ? "Edit " + userRole : "Add User Role"}>
          <Button
              type="CancelButton"
              name="buttonCancel"
              className="pull-right btnCancelOperation"
              label={LOOKUP.common.cancel.text}
              onTouchTap={() => this.redirectToRoleList()}
          />
        </PageHeaderWithButton>
        <CardSimple className="p-1">
          <div className="row">
            <div className="col-lg-6">
              <TextInput
                name={name + "Name"}
                label={"Role Name"}
                floatingLabelText={"Role Name"}
                hintText={"Role Name"}
                fullWidth={true}
                maxLength={50}
                disabled={!p.isRoleEditable}
                required={true}
              />
              {p.isRoleEditable &&
                <p>The name is limited to a maximum of 50 characters.</p>}
            </div>
            <div className="col-lg-6 mt-2">
              {p.isRoleEditable &&
                <Button
                  name="buttonSave"
                  className="btnNewBrandPOS mr-2 pull-right"
                  label="Save Role"
                  primary={true}
                  onTouchTap={() => this.saveRole()}
                />
              }
            </div>
          </div>
          {isEditPage &&
            <div className="row">
              {p.isRoleEditable ?
                <div className="col-sm-12 mb-2">
                  <h4>Select Permission(s)</h4>
                  <div>Please choose the permissions you would like to grant to this role</div>
                </div> :
                <div className="col-sm-12">
                  <h4>Permissions</h4>
                  <div className="mb-2">You can't modify default role's permissions</div>
                </div>}

              {(groupedPermissions || []).map(group => group.type !== "SecurityPolicies" &&
                <div className="col-xs-6 col-sm-6 col-lg-4">
                  <div className="row">
                    <h6 className="col-sm-12 p-0">{group.type.split("Policies")[0]}</h6>
                   </div>
                  <div className="row mb-1">
                  {group.items.map(pol =>
                    <div key={`${name}Policy-${pol.value}`} className="col-sm-12 p-0 mb-1">
                      <CheckInput
                        key={`${pol.value.replace(/ /g, "_")}`}
                        name={`${name}Policy-${pol.value}`}
                        text={pol.text}
                        className="checkBoxLabels m-0 pt-0 pb-0"
                        disabled={!p.isRoleEditable}
                      />
                    </div>)}
                  </div>
                </div>
              )}
            </div>
          }
        </CardSimple>
        <div className="row">
          {/* LEFT PANEL */}
          <div className="col-xs-12 col-md-6">
            {this.state.status === "EDIT" ? (
              <div>
                <div className="row">
                  <div className="col-lg-12 p-0">
                    <h5 className="pb-2" style={{ fontSize: '16px' }}>
                      Select which <strong>Reports</strong>{" "}
                      {userRole ? userRole : "the employee"} will
                      have access to:
                    </h5>
                  </div>
                </div>
                <Card>
                  <CardContent >
                    <div className="row pt-3 pb-3">
                      <div className="col-sm-6 pr-0">
                          <FormControlLabel
                              control={
                                  <Checkbox
                                      id="checkboxSelectAllReports"
                                      name={p.name}
                                      checked={this.state.reportCheckboxStatus === 'all'}
                                      onChange={(e) => this.handleCheckAllReport(e.target.checked)} // Use onChange instead of onCheck
                                  />
                              }
                              label={<Label selected={this.state.reportCheckboxStatus === 'all'} type="Report" />}
                              labelPlacement="end" // Align label to the right of the checkbox
                              sx={{ textAlign: 'left', labelStyle: { textAlign: 'left' }, '& .MuiTypography-root': { ...p.labelStyle } }} // Custom label style
                          />
                      </div>
                      <div className="col-sm-6 text-right">
                        <Button
                          name="pull-right buttonSave"
                          className="btnNewBrandPOS"
                          label="Save Report Access"
                          primary={true}
                          onTouchTap={() => this.saveReportRole()}
                        />
                      </div>
                    </div>
                    <div className="row">
                      {reportsList && Object.entries(reportsList).filter(([groupName, reports]) => groupName !== `null`).map(([groupName, reports]) => {
                        const allChecked = reports.every(item => this.state.reportAccess[item.id]);
                        const someChecked = reports.some(item => this.state.reportAccess[item.id]);
                        const isIndeterminate = !allChecked && someChecked;

                        return (
                          <div className="col-lg-12" key={groupName}>
                            <div className="d-flex align-items-center mb-2">
                              <h4 className="m-0 mr-2">{groupName}</h4>
                              <CheckInput
                                  name={`roleReport-${groupName}`}
                                  className="checkBoxLabels"
                                  checked={allChecked}
                                  onCheck={(e) => this.selectGroupReports(groupName, e.target.checked)}
                              />
                              
                            </div>

                            {reports.map(item => (
                              <div className="col-lg-10 p-0" key={`${item.text.replace(/ /g, "_")}`}>
                                <CheckInput
                                  id={`${item.text.replace(/ /g, "_")}`}
                                  name={`roleReport-${item.id}`}
                                  text={item.text}
                                  className="checkBoxLabels"
                                  checked={!!this.state.reportAccess[item.id]}
                                  onCheck={(e) => this.handleCheckboxChange(item.id, e.target.checked)}
                                />
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </CardContent >

                </Card>
              </div>
            ) : null}
          </div>

          {/* RIGHT PANEL */}
          <div className="col-xs-12 col-md-6">
            {this.state.status === "EDIT" ? (
              <div>
                <div className="row">
                  <div className="col-lg-12 p-0">
                    <h5 className="pb-2" style={{ fontSize: '16px' }}>
                      Select which <strong>Pages</strong>{" "}
                      {userRole ? userRole : "the employee"} will
                      have access to:
                    </h5>
                  </div>
                </div>
                <Card>
                  <CardContent >
                    <div className="row pt-3 pb-3">
                      <div className="col-sm-6 pr-0">
                          <FormControlLabel
                              control={
                                  <Checkbox
                                    id="checkboxSelectAllPages"
                                      name={p.name}
                                      checked={this.state.pageCheckboxStatus === 'all'}
                                      onChange={this.handleCheckAllPage} // Use onChange instead of onCheck
                                  />
                              }
                              label={<Label selected={this.state.pageCheckboxStatus === 'all'} type="Page" />}
                              labelPlacement="end" // Align label to the right of the checkbox
                              sx={{ textAlign: 'left', labelStyle: { textAlign: 'left' }, '& .MuiTypography-root': { ...p.labelStyle } }} // Custom label style
                          />

                      </div>
                      <div className="col-sm-6 text-right">
                        <Button
                          name="pull-right buttonSave"
                          className="btnNewBrandPOS"
                          label="Save Page Access"
                          primary={true}
                          onTouchTap={() => this.savePageRole()}
                        />
                      </div>
                    </div>
                    <div className="row">
                      {
                        (pageList || []).map(category => {
                          return (
                            <div className="col-lg-12" key={`${category.category.replace(/ /g,"_")}`}>
                              <h4 style={{ textTransform: 'uppercase' }}>{category.category}</h4>
                              {category.pages.map(page => {
                                return (
                                  <div className="col-lg-10 p-0" key={`${name}Page-${page.id}`}>
                                    <CheckInput
                                      id={`${name}Page-${page.id}`}
                                      name={`${name}Page-${page.id}`}
                                      text={page.text}
                                      className="checkBoxLabels"
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })
                      }
                    </div>
                  </CardContent >
                </Card>
              </div>
            ) : null}
          </div>
        </div>
      </Grid>
    );
  }
}

function mapStateToProps(state, props) {
  return {
        allState: state,
        formState: state.form,
        accessModel: state.form.roleId && selectUserRoleAccessModel(state, name, state.form.roleId),
        rolesList: state.entity.rolesList,
        policies: state.entity.policies && state.entity.policies,
        userRoleReport: state.form.userRoleMapping,
        userRolePage: state.entity.userRolePage,
        saveSuccess: state.form[name + "SaveSuccess"],
        saveError: state.form[name + "SaveError"],
        hasWebMenu: state.common.applicationSettings.hasWebMenu,
        isRoleEditable: state.form[name + "IsRoleEditable"] || null,
        roleName: state.form[name + "Name"] || null
    };
}

function mapDispatchToProps(dispatch) {
    return {
        initializeRole: (compName) => dispatch(initializeRole(compName)),
        getRoles: () => dispatch(getRoles()),
        getRole: (id, compName) => dispatch(getRole(id, compName)),
        saveRole: (model, name) => dispatch(saveRole(model, name)),
        updateRole: (model) => dispatch(updateRole(model)),
        getPolicies: () => dispatch(getPolicies()),
        getUserReportRole: (id) => dispatch(getUserReportRole(id)),
        getUserPageRole: (id) => dispatch(getUserPageRole(id)),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formError: (name, error) => dispatch({ type: "FORM_ERROR", name, error }),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        saveUserReportRole: (userrole) => dispatch(saveUserReportRole(userrole, name)),
        saveUserPageRole: (userrole) => dispatch(saveUserPageRole(userrole, name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(UserRoleSave));
